<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <router-link :to="`/licenseapplys/${activeName}/${pageIndex}`"> 
                    <i class="el-icon-arrow-left" style="cursor: pointer;"></i>
                    牌照查看
                    </router-link>
                    / 牌照详情 
					
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="purchasesee-box">
            <p class="purchasesee-title">车主及业务员信息</p>
            <div class="purchasesee-padding">
                <ul class="seelicense-item1">
                    <li>车主:{{seelicenseApplylist.ownerName}}</li>
                    <li>手机号:{{seelicenseApplylist.ownerCellphoneNumber}}</li>
                    <li>办理业务员:{{seelicenseApplylist.applicantName}}</li>
                </ul>
                <ul class="seelicense-item1">
                    <li>地区:{{seelicenseApplylist.provinceName}}{{seelicenseApplylist.cityName}}</li>
                    <li>身份证号:{{seelicenseApplylist.ownerIdentityCards}}</li>
                </ul>
                <ul class="seelicense-itemphoto" v-if="seelicenseApplylist.ownerIdentityCardsPhoto">
                    <li>身份证照片:</li>
                    <li v-for="item in seelicenseApplylist.ownerIdentityCardsPhoto">
                        <img :src="'/api/static'+item" alt />
                    </li>
                </ul>
                <ul class="seelicense-item1">
					<li>车主:{{seelicenseApplylist.ownerName}}</li>     
					<li>办理业务员:{{seelicenseApplylist.applicantName}}</li>
                </ul>
            </div>

            <p class="purchasesee-title" style="border-left: none;"></p>

            <p class="purchasesee-title">基本信息</p>
            <div class="purchasesee-padding">
                <ul class="seelicense-item3">
                    <li>设备编号:{{seelicenseApplylist.equipmentCode}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>环保编码：{{seelicenseApplylist.environmentalProtectionNumber}}</li>
                    <li>排放登记: {{seelicenseApplylist.emissionRegistration}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>发动机功率：{{seelicenseApplylist.enginePower}}</li>
                    <li>机械品牌: {{seelicenseApplylist.machineryBrand}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>机械颜色：{{seelicenseApplylist.machineryColor}}</li>
                    <li>机械类型: {{seelicenseApplylist.machineryType}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>生产国别：{{seelicenseApplylist.productionCountry}}</li>
                    <li>整机架号: {{seelicenseApplylist.frameNo}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>燃油类型：{{seelicenseApplylist.fuelType}}</li>
                    <li>发动机号: {{seelicenseApplylist.engineNumber}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>整机质量：{{seelicenseApplylist.overallQuality}}</li>
                    <li>出厂日期: {{seelicenseApplylist.productionDateStr}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>核载质量：{{seelicenseApplylist.nuclearInformation}}</li>
                    <li>生产厂家：{{seelicenseApplylist.factory}}</li>
                </ul>
                <ul class="seelicense-itemphoto" v-if="seelicenseApplylist.mechanicalPictures">
                    <li>机械图片:</li>
                    <li v-for="item in seelicenseApplylist.mechanicalPictures">
                        <img :src="'/api/static'+item" alt />
                    </li>
                </ul>
            </div>
            <p class="purchasesee-title">邮寄地址</p>
            <div class="purchasesee-padding">
                <p class="seelicense-item5">收货人姓名: {{seelicenseApplylist.shippingName}}</p>
                <p class="seelicense-item5">收货人手机号: {{seelicenseApplylist.shippingCellphoneNumber}}</p>
                <p class="seelicense-item5">收货地址: {{seelicenseApplylist.shippingAddress}}</p>
            </div>
            <p class="purchasesee-title">易车信息</p>
            <div class="purchasesee-padding">
                <ul
                    class="seelicense-item4"
                    v-if="seelicenseApplylist.receiverName || seelicenseApplylist.receiverCellphoneNumber || seelicenseApplylist.receiverIdentityCards"
                >
                    <li
                        v-if="seelicenseApplylist.receiverName || seelicenseApplylist.receiverCellphoneNumber || seelicenseApplylist.receiverIdentityCards"
                    >车主变更</li>
                    <li
                        v-if="seelicenseApplylist.receiverName"
                    >接收人:{{seelicenseApplylist.receiverName}}</li>
                    <li
                        v-if="seelicenseApplylist.receiverCellphoneNumber"
                    >接收人电话: {{seelicenseApplylist.receiverCellphoneNumber}}</li>
                    <li
                        v-if="seelicenseApplylist.receiverIdentityCards"
                    >接收人证件号: {{seelicenseApplylist.receiverIdentityCards}}</li>
                </ul>
                <p class="seelicense-item2" v-else>无</p>
            </div>
        </div>
    </div>
</template>

<script>
import { getLicenseApply, examineOrganizationLicenseApply } from '@/api/index';
export default {
    name: 'seelicenseapplys',
    data() {
        return {
			activeName: this.$route.params.activeName,
			pageIndex: this.$route.params.pageIndex,
            licenseApplyId: '',
            seelicenseApplylist: {}, //查看
            seelicenseVos: [],
            seenumberprice: []
        };
    },
    created() {
        this.licenseApplyId = this.$route.params.licenseApplyId;
        // 查看
        getLicenseApply({
            licenseApplyId: this.licenseApplyId
        }).then(res => {
            this.seelicenseApplylist = res.data;
            if (res.data.ownerIdentityCardsPhoto) {
                this.seelicenseApplylist.ownerIdentityCardsPhoto = res.data.ownerIdentityCardsPhoto.split(',');
            }
            if (res.data.mechanicalPictures) {
                this.seelicenseApplylist.mechanicalPictures = res.data.mechanicalPictures.split(',');
            }
        });
    },
    methods: {
        // 通过
        passseeApply() {
            var that = this;
            var organlaid = this.seeorganizationLicenseApplyId.split(',');
            this.$confirm('确定要通过吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    examineOrganizationLicenseApply({
                        isPass: 1,
                        organizationLicenseApplyIds: organlaid
                    }).then(res => {
                        // 获取数据成功后的其他操作
                        this.$router.push('/organizationlicenseapply');
                        this.$message({
                            message: res.message,
                            type: 'success'
                        });
                        listTaskRemindNum({}).then(ress => {
                            this.$store.state.totalNum = ress.data.totalNum;
                        });
                    });
                })
                .catch(() => {});
        },
        // 回退
        fallbackseeApply() {
            var that = this;
            var organlaid = this.seeorganizationLicenseApplyId.split(',');
            this.$confirm('确定要退回吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    examineOrganizationLicenseApply({
                        isPass: 2,
                        organizationLicenseApplyIds: organlaid
                    }).then(res => {
                        // 获取数据成功后的其他操作
                        this.$router.push('/organizationlicenseapply');
                        this.$message({
                            message: res.message,
                            type: 'success'
                        });
                        console.log(res);
                        listTaskRemindNum({}).then(ress => {
                            this.$store.state.totalNum = ress.data.totalNum;
                        });
                    });
                })
                .catch(() => {});
        }
    }
};
</script>

<style scoped>
.purchasesee-box {
    background: #fff;
    padding: 20px 0;
}
.purchasesee-title {
    height: 30px;
    line-height: 30px;
    background: #f0f0f0;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 2px;
    border-left: 5px solid #437af4;
    text-indent: 30px;
}
.purchasesee-padding {
    padding: 20px 0;
}
.seelicense-item1 {
    display: flex;
    display: -webkit-flex;
    padding: 0 35px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
    margin-bottom: 20px;
}
.seelicense-item1 li {
    width: 200px;
    margin-right: 20px;
}
.seelicense-item1 li:last-child {
    flex: 1;
}
.seelicense-itemphoto {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    list-style: none;
    padding-left: 35px;
    color: #666;
}
.seelicense-itemphoto li {
    width: 200px;
    margin-right: 20px;
}
.seelicense-itemphoto li:first-child {
    width: 100px;
}
.seelicense-itemphoto li img {
    width: 100%;
}
.seelicense-item2 {
    padding: 0 35px;
    margin-top: 15px;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item3 {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    padding: 0 35px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
    margin-bottom: 10px;
}
.seelicense-item3 li {
    width: 350px;
}
.seelicense-item4 {
    margin: 0 35px;
    background: #f8f8fb;
    padding: 20px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item4 li {
    margin-bottom: 10px;
}
.seelicense-item5 {
    padding-left: 35px;
    height: 32px;
    line-height: 32px;
    letter-spacing: 1px;
    color: #666;
}
.purchasesee-text1,
.purchasesee-text2 {
    height: 32px;
    line-height: 32px;
    text-indent: 15px;
}

.purchasesee-text2 {
    text-indent: 50px;
}
.purchasesee-table {
    width: 50%;
    margin: 10px 0 30px 50px;
}
.purchasesee-linceinfo {
    margin: 10px 50px;
    display: flex;
    display: -webkit-flex;
}
.purchasesee-linceitem {
    width: 30%;
}
.purchasesee-linceitem:nth-child(2) {
    margin: 0 3%;
}

.organ-box {
    margin-bottom: 20px;
    text-align: right;
}
.apply-box {
    display: flex;
    display: -webkit-flex;
}
.apply-box p {
    flex: 1;
}

.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
